<div class="table-legend" *ngIf="items.length">
  <span class="table-legend__title">Referencia:</span>
  <span class="table-legend__item" *ngFor="let item of items">
    <i [class]="'pi ' + item.icon" class="table-legend__icon"></i>
    <ng-container *ngIf="item.boldWord; else plainText">
      {{ item.text.split(item.boldWord)[0] }}<b>{{ item.boldWord }}</b>{{ item.text.split(item.boldWord)[1] || '' }}
    </ng-container>
    <ng-template #plainText>{{ item.text }}</ng-template>
  </span>
</div>
